/**
 * initialize event listener for quantity modifier button
 */
export const featureBanner = (function () {
  'use strict';

  var init = function () {
    breakpointChecker();
    breakpointCheckerTablet();
    breakpointCheckerMobile();
  };


    var breakpointChecker = function () {
        var banner = document.querySelector("#product-listing-banner");
        var productTile = document.querySelectorAll(".product-grid-wrapper.desktop-results .product-listing-tile");
        // For Desktop screen size
        if (banner !== null && (productTile.length === 1 || productTile.length === 2) && productTile[0] && productTile[0].parentNode) {
            productTile[0].parentNode.insertBefore(banner, productTile[0]);
        } else if (banner !== null && productTile.length > 2 && productTile[2] && productTile[2].parentNode) {
            productTile[2].parentNode.insertBefore(banner, productTile[2].nextSibling);
        }
    };

    var breakpointCheckerTablet = function () {
        var searchBanner = document.querySelector("#product-listing-banner-tablet");
        var productTile = document.querySelectorAll(".product-grid-wrapper.tablet-results .product-listing-tile");
        // For Tablet screen size
        if (searchBanner !== null && productTile.length === 1 && productTile[0] && productTile[0].parentNode) {
            productTile[0].parentNode.insertBefore(searchBanner, productTile[0]);
        } else if (searchBanner !== null && productTile.length >= 2 && productTile[1] && productTile[1].parentNode) {
            productTile[1].parentNode.insertBefore(searchBanner, productTile[1].nextSibling);
        }
    };

    var breakpointCheckerMobile = function () {
        var banner = document.querySelector("#product-listing-banner-mobile");
        var productTile = document.querySelectorAll(".product-grid-wrapper.mobile-results .product-listing-tile");
        // For Mobile screen size
        if (banner !== null && productTile.length === 1 && productTile[0] && productTile[0].parentNode) {
            productTile[0].parentNode.insertBefore(banner, productTile[0]);
        } else if (banner !== null && productTile.length >= 2 && productTile[1] && productTile[1].parentNode) {
            productTile[1].parentNode.insertBefore(banner, productTile[1].nextSibling);
        }
    };

  return {
    init: init
  };

});



// WEBPACK FOOTER //
// ./javascript/product-search-page/raw-from-relab/plp-product-grid.js